import React from 'react';
import  './Footer.css';
import {FaCopyright} from "react-icons/fa"

function Footer() {
    return (
    <div>
    <footer>
        <span>Created By <a>Rutvik</a> | <FaCopyright class="far fa-copyright"></FaCopyright> 2022 All rights reserved.</span>
    </footer>
    </div>
    )};

export default Footer;

